import { lazy } from 'react';
import { Suspense } from '@app/components/Suspense';
import activeAccountProvider from './hoc/activeAccountProvider';

const loadingMessage = 'Loading Page...';
const Page = lazy(() => import('./Page'));

export default activeAccountProvider(props => <Suspense loaderMessage={loadingMessage} component={<Page {...props} />} />);
